export const BLOCKS_AND_SLIDES_MATERIAL = "blocks_and_slides";

const PASS_THROUGH_MATERIAL_PREFIXES = new Set(["G", "GC", "HE"]);

function normalizePrefix(prefix?: string | null): string {
  return prefix?.trim().toUpperCase() || "";
}

export function hasDeterministicPassThroughMaterialDefault(
  prefix?: string | null
): boolean {
  return PASS_THROUGH_MATERIAL_PREFIXES.has(normalizePrefix(prefix));
}

export function getDefaultMaterialForNewSpecimen(
  prefix: string | null | undefined,
  fallbackMaterial: string
): string {
  if (hasDeterministicPassThroughMaterialDefault(prefix)) {
    return BLOCKS_AND_SLIDES_MATERIAL;
  }

  return fallbackMaterial;
}

export function applyPassThroughMaterialDefault(
  prefix: string | null | undefined,
  currentMaterial?: string | null
): string {
  const material = currentMaterial || "";

  // These prefixes deterministically receive processed material, so replace the
  // AI's formalin fallback with blocks and slides.
  const isPassThroughPrefix =
    hasDeterministicPassThroughMaterialDefault(prefix);
  if (isPassThroughPrefix && material.trim() === "formalin_jar") {
    return BLOCKS_AND_SLIDES_MATERIAL;
  }

  if (material.trim()) return material;

  return getDefaultMaterialForNewSpecimen(prefix, material);
}

export function applyPassThroughMaterialDefaultsToSpecimens<
  T extends { material?: string | null }
>(prefix: string | null | undefined, specimens: T[]): T[] {
  let changed = false;
  const next = specimens.map((specimen) => {
    const material = applyPassThroughMaterialDefault(prefix, specimen.material);
    if (material === (specimen.material || "")) return specimen;
    changed = true;
    return { ...specimen, material };
  });

  return changed ? next : specimens;
}
